import { Turbo } from '@hotwired/turbo-rails'
import '../controllers'

// Disable Turbo Drive globally — existing SPA handles navigation
Turbo.session.drive = false
